import styled from 'styled-components';
import Grid from 'styled-components-grid';

const Col = styled(Grid.Unit)`
  padding-left: ${({ theme }) => `${theme.grid.gutter / 2}px`};
  padding-right: ${({ theme }) => `${theme.grid.gutter / 2}px`};
`;

export default Col;
